module.exports = __webpack_public_path__ + "static/media/7b.a24cecb2.svg";